var trackBorderRadius = {
  default: '2',
  l: '4'
};
var trackBaseBorderRadius = {
  default: '1',
  l: '2'
};
var getTrackSize = function getTrackSize(size) {
  var sizes = {
    default: '2px',
    l: '4px'
  };
  return sizes[size] || sizes.default;
};
var getProgressSize = function getProgressSize(size) {
  var sizes = {
    default: '4px',
    l: '8px'
  };
  return sizes[size] || sizes.default;
};
var getTrackBorderRadius = function getTrackBorderRadius(direction, size, position) {
  var baseBorderRadius = trackBaseBorderRadius[size];
  var borderRadius = trackBorderRadius[size];
  if (position === 'default') {
    return baseBorderRadius;
  }
  if (position === 'standalone') {
    return borderRadius;
  }
  var horizontalRadius = position === 'start' ? [borderRadius, baseBorderRadius, baseBorderRadius, borderRadius] : [baseBorderRadius, borderRadius, borderRadius, baseBorderRadius];
  var verticalRadius = position === 'start' ? [borderRadius, borderRadius, baseBorderRadius, baseBorderRadius] : [baseBorderRadius, baseBorderRadius, borderRadius, borderRadius];
  return direction === 'horizontal' ? horizontalRadius : verticalRadius;
};

export { getProgressSize, getTrackBorderRadius, getTrackSize };
//# sourceMappingURL=Track.helpers.js.map
